module.exports = __webpack_public_path__ + "static/media/Img_1.6152e7ea.jpg";